import React from 'react';
import {motion} from 'framer-motion';
import {FiPhone} from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const Hero=()=> {
  return (
    <section id="home" className="relative min-h-screen flex items-center pt-24 pb-12 overflow-hidden bg-white">
      {/* Background Decorative Elements */}
      <div className="absolute top-0 right-0 w-1/3 h-full bg-royal/[0.03] -skew-x-12 transform origin-top-right hidden lg:block"></div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 w-full">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <motion.div initial={{opacity: 0,x: -30}} animate={{opacity: 1,x: 0}} transition={{duration: 0.8}} className="text-center lg:text-left">
            <div className="inline-flex items-center gap-2 py-2 px-4 rounded-full bg-brandOrange/10 text-brandOrange font-bold text-sm tracking-widest uppercase mb-8 border border-brandOrange/20">
              <span className="w-2 h-2 rounded-full bg-brandOrange animate-pulse"></span> Weston-super-Mare &amp; Surrounds
            </div>
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-extrabold text-royal mb-8 leading-[1.1] tracking-tight">
              Automatic Lessons <br /> <span className="text-brandOrange">Now Available</span>
            </h1>
            <p className="text-xl md:text-2xl text-gray-600 mb-12 max-w-2xl mx-auto lg:mx-0 leading-relaxed font-medium">
              Join the hundreds of confident drivers who passed with Crossroads. We specialize in stress-free automatic tuition for nervous and first-time learners.
            </p>
            <div className="flex flex-col sm:flex-row gap-5 justify-center lg:justify-start">
              <a href="#contact" className="bg-brandOrange hover:bg-brandOrangeDark text-white px-12 py-5 rounded-2xl font-bold text-xl transition-all transform hover:scale-105 shadow-2xl hover:shadow-orange-300 active:scale-95">
                Book Your Lesson
              </a>
              <a href="#services" className="bg-white text-royal border-2 border-royal/10 hover:border-royal/30 px-12 py-5 rounded-2xl font-bold text-xl transition-all shadow-xl active:scale-95">
                Learn More
              </a>
            </div>
            <div className="mt-16 flex items-center justify-center lg:justify-start gap-8 border-t border-gray-100 pt-10">
              <div className="text-left">
                <p className="text-3xl font-black text-royal mb-1">81%</p>
                <p className="text-sm font-bold text-gray-400 uppercase tracking-widest">First Time Pass</p>
              </div>
              <div className="w-px h-12 bg-gray-200"></div>
              <div className="text-left">
                <div className="flex text-brandOrange mb-1">
                  {[...Array(5)].map((_,i)=> (
                    <svg key={i} className="w-5 h-5 fill-current" viewBox="0 0 20 20">
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                    </svg>
                  ))}
                </div>
                <p className="text-sm font-bold text-gray-400 uppercase tracking-widest">Top Rated School</p>
              </div>
            </div>
          </motion.div>

          {/* Right Image Content */}
          <motion.div initial={{opacity: 0,scale: 0.9}} animate={{opacity: 1,scale: 1}} transition={{duration: 1,delay: 0.2}} className="relative">
            <div className="relative z-10 rounded-[3rem] overflow-hidden shadow-[0_32px_64px_-16px_rgba(30,58,138,0.25)] border-[16px] border-white ring-1 ring-gray-100">
              <img src="https://i.postimg.cc/vm0Y0rJv/2026-03-29-16-12-45.jpg" alt="Automatic Driving Lesson student" className="w-full h-auto object-cover object-right aspect-[4/5] lg:aspect-auto" />
            </div>
            {/* Floating Achievement - Moved to Bottom Right */}
            <motion.div animate={{y: [0,-12,0]}} transition={{duration: 5,repeat: Infinity,ease: "easeInOut"}} className="absolute bottom-12 -right-8 z-20 bg-white p-5 rounded-2xl shadow-2xl border border-gray-50 flex items-center gap-4 hidden sm:flex">
              <div className="w-12 h-12 bg-royal rounded-full flex items-center justify-center text-white shadow-lg">
                <SafeIcon icon={FiPhone} className="w-6 h-6" />
              </div>
              <div className="pr-4">
                <p className="text-[10px] text-gray-400 font-black uppercase tracking-widest leading-none mb-1">Available Now</p>
                <p className="text-lg font-extrabold text-royal">Book Today</p>
              </div>
            </motion.div>
            {/* Background Decoration */}
            <div className="absolute -top-12 -right-12 w-64 h-64 bg-royal/10 rounded-full blur-3xl -z-10"></div>
            <div className="absolute -bottom-16 -left-16 w-80 h-80 bg-brandOrange/10 rounded-full blur-3xl -z-10"></div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Hero;